import { Navigate } from "react-router-dom";

const SESSION_KEY = "user";
const TOKEN_KEY = "authToken";

/**
 * Synchronously check whether the user is already logged in via sessionStorage.
 * Keeps consistent with what Login.jsx stores.
 */
function isAlreadyLoggedIn() {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (!token) return false;

  try {
    const stored = sessionStorage.getItem(SESSION_KEY);
    if (!stored) return false;
    const parsed = JSON.parse(stored);
    return !!(parsed.isLoggedIn && parsed.userData);
  } catch {
    sessionStorage.removeItem(SESSION_KEY);
    return false;
  }
}

function RedirectIfLoggedIn({ children }) {
  if (isAlreadyLoggedIn()) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

export default RedirectIfLoggedIn;
